import { render, staticRenderFns } from "./PalettesPicker.vue?vue&type=template&id=58702140&scoped=true&"
import script from "./PalettesPicker.vue?vue&type=script&lang=js&"
export * from "./PalettesPicker.vue?vue&type=script&lang=js&"
import style0 from "./PalettesPicker.vue?vue&type=style&index=0&id=58702140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58702140",
  null
  
)

export default component.exports